import type { MapManifest } from '@/gameplay/types'
import { maskGridSlots } from './grid'

const TILE = 1.7

/**
 * Бункер: крупная решётка.
 * Spawn в южном тамбуре → центральный зал → северный шлюз Exit.
 * Перегородки только в пустых клетках маски; props — solid.
 */
const BUNKER_MASK = [
  '##.###.##', // r0 юг — тамбур
  '##.###.##',
  '#########', // расширение
  '###...###', // узкий проход
  '#########', // центральный зал
  '###.###.#',
  '#########',
  '##.###.##',
  '##.###.##', // север к шлюзу
]

const ORIGIN_X = -4 * TILE
const ORIGIN_Z = -8.2
const FIELD_MAX_Z = ORIGIN_Z + 8 * TILE

export const bunkerMap: MapManifest = {
  id: 'bunker',
  displayName: 'Бункер',
  description: 'Коридоры и залы на крупной решётке. Южный тамбур → центр → гермошлюз.',
  tileSize: TILE,
  slots: maskGridSlots(BUNKER_MASK, ORIGIN_X, ORIGIN_Z, TILE),
  exitZone: { center: { x: 0, y: 0, z: FIELD_MAX_Z + 2.4 }, radius: 1.8 },
  // Смотрим на +Z к полю
  spawn: { position: { x: -2.2 * (TILE / 1.1), y: 1.7, z: ORIGIN_Z - TILE * 1.6 }, yaw: Math.PI },
  bounds: {
    minX: -4.5 * TILE - 2,
    maxX: 4.5 * TILE + 2,
    minZ: ORIGIN_Z - TILE * 2.5,
    maxZ: FIELD_MAX_Z + 4,
  },
  fieldCentroid: { x: 0, y: 0, z: ORIGIN_Z + 4 * TILE },
  minGrid: { cols: 9, rows: 9 },
  walls: [
    // Оболочка
    { x: 0, z: ORIGIN_Z - TILE * 2.2, w: 9 * TILE + 4, d: 0.55, h: 3.4 },
    { x: -4.5 * TILE - 1.2, z: ORIGIN_Z + 4 * TILE, w: 0.55, d: 12 * TILE, h: 3.4 },
    { x: 4.5 * TILE + 1.2, z: ORIGIN_Z + 4 * TILE, w: 0.55, d: 12 * TILE, h: 3.4 },
    { x: -2.6 * TILE, z: FIELD_MAX_Z + 3.2, w: 4.2 * TILE, d: 0.55, h: 3.4 },
    { x: 2.6 * TILE, z: FIELD_MAX_Z + 3.2, w: 4.2 * TILE, d: 0.55, h: 3.4 },
    // Заглушки пустых клеток тамбура (c2,c6 в r0/r1)
    { x: -2 * TILE, z: ORIGIN_Z + 0.5 * TILE, w: TILE * 0.85, d: TILE * 1.3, h: 3.1 },
    { x: 2 * TILE, z: ORIGIN_Z + 0.5 * TILE, w: TILE * 0.85, d: TILE * 1.3, h: 3.1 },
    // Пустые c3/c4/c5 на узком проходе r3
    { x: 0, z: ORIGIN_Z + 3 * TILE, w: TILE * 2.6, d: TILE * 0.85, h: 3.1 },
    // Пустая c5 в r5
    { x: TILE, z: ORIGIN_Z + 5 * TILE, w: TILE * 0.85, d: TILE * 0.85, h: 3.1 },
    // Стойки шлюза
    { x: -1.7, z: FIELD_MAX_Z + 1.6, w: 0.55, d: 0.55, h: 3.4 },
    { x: 1.7, z: FIELD_MAX_Z + 1.6, w: 0.55, d: 0.55, h: 3.4 },
  ],
  props: [
    { x: -3.8 * TILE, z: ORIGIN_Z - TILE, w: 1.3, d: 1.3, h: 1.3 },
    { x: 3.8 * TILE, z: ORIGIN_Z - TILE, w: 1.3, d: 1.3, h: 1.3 },
    { x: -3.2 * TILE, z: ORIGIN_Z + 4 * TILE, w: 1.4, d: 1.4, h: 1.5 },
    { x: 3.5 * TILE, z: ORIGIN_Z + 6 * TILE, w: 1.2, d: 1.2, h: 1.4 },
  ],
  platforms: [{ x: 0, z: ORIGIN_Z + 4 * TILE, w: 10 * TILE, d: 14 * TILE, y: 0 }],
  // ~18–23% от ~65 слотов
  mineCountRange: { min: 10, max: 15 },
  defaultMode: 'clear',
}
